import React, { Fragment } from 'react';
import { array, object, string } from 'prop-types';

import Information from 'routes/course/components/Information';

function Detail({ elementRef, detailInfo, tabLabel }) {
  return (
    <Fragment>
      <section ref={elementRef}>
        <h2>{tabLabel}</h2>
        <Information info={detailInfo} />
      </section>
    </Fragment>
  );
}

Detail.propTypes = {
  elementRef: object.isRequired,
  detailInfo: array.isRequired,
  tabLabel: string.isRequired,
};

export default Detail;
